export default __webpack_public_path__ + "static/media/logo.69432c7c.svg";